export default "__VITE_ASSET__D2TR9b9A__"